<template>
  <div class="d-flex col" :class="`col-${cols} offset-${offset}`">
    <v-select
      :label="config.label"
      :items="[
        { label: config.labelAtivo, value: true },
        { label: config.labelInativo, value: false },
      ]"
      :item-text="'label'"
      :item-value="'value'"
      v-model="value"
      outlined
      dense
      @keyup.enter="$emit('enter')"
    ></v-select>
  </div>
</template>

<script>
export default {
  name: "AtivoSelectComponent",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    cols: {
      type: Number,
      default: 12,
    },
    offset: {
      type: Number,
      default: 0,
    },
    config: {
      type: Object,
      default: () => ({
        labelAtivo: "Sim",
        labelInativo: "Não",
        label: "Ativo",
      }),
    },
  },
  watch: {
    value(v) {
      this.$emit("input", v);
    },
  },
};
</script>
